import { Button } from "@app/ui";
import { FeedbackComposer } from "../../features/feedback/index.js";
import { FEEDBACK_EMAIL } from "../../features/feedback/feedback.js";
import { useI18n } from "../../lib/useI18n.js";
import { toast, useSettingsStore } from "../../stores/index.js";
import { SettingsCard } from "./SettingsCard.js";
import { SettingsSection } from "./SettingsSection.js";

/** "About & feedback" — app info, feedback, and the developer-options unlock. */
export function AboutSettings() {
  const { locale, t } = useI18n();
  const mobileScreenshotFeedback = useSettingsStore((s) => s.mobileScreenshotFeedback);
  const setMobileScreenshotFeedback = useSettingsStore((s) => s.setMobileScreenshotFeedback);
  const developerMode = useSettingsStore((s) => s.developerMode);
  const setDeveloperMode = useSettingsStore((s) => s.setDeveloperMode);

  return (
    <div className="flex flex-col gap-8">
      <SettingsSection title={t("about.about")}>
        <SettingsCard id="about" title="YourCalendar">
          <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-1 text-sm">
            <dt className="text-muted-foreground">{t("common.version")}</dt>
            <dd className="tabular-nums">{__APP_VERSION__}</dd>
            <dt className="text-muted-foreground">{t("common.build")}</dt>
            <dd className="tabular-nums">{new Date(__BUILD_TIME__).toLocaleString(locale)}</dd>
          </dl>
        </SettingsCard>
      </SettingsSection>

      <SettingsSection title={t("common.feedback")}>
        <SettingsCard id="feedback" title={t("about.sendFeedback")} description={t("about.sendFeedback.description", { email: FEEDBACK_EMAIL })}>
          <FeedbackComposer source="settings" />
        </SettingsCard>

        <SettingsCard id="screenshot-feedback" title={t("about.screenshotFeedback")} description={t("about.screenshotFeedback.description")}>
          <div className="flex flex-wrap gap-2">
            <Button variant={mobileScreenshotFeedback ? "primary" : "outline"} onClick={() => void setMobileScreenshotFeedback(true)}>{t("common.on")}</Button>
            <Button variant={!mobileScreenshotFeedback ? "primary" : "outline"} onClick={() => void setMobileScreenshotFeedback(false)}>{t("common.off")}</Button>
          </div>
        </SettingsCard>
      </SettingsSection>

      <SettingsSection title={t("about.advanced")}>
        <SettingsCard
          id="developer-options"
          title={t("about.developerOptions")}
          description={t("about.developerOptions.description")}
        >
          <div className="flex items-center gap-3">
            <Button
              variant={developerMode ? "primary" : "outline"}
              onClick={() => void setDeveloperMode(true).then(() => toast.info(t("about.developerUnlocked")))}
            >
              {t("common.on")}
            </Button>
            <Button variant={!developerMode ? "primary" : "outline"} onClick={() => void setDeveloperMode(false)}>{t("common.off")}</Button>
          </div>
        </SettingsCard>
      </SettingsSection>
    </div>
  );
}
